module.exports = __webpack_public_path__ + "static/media/4.7b0d5db0.jpg";